import { render, staticRenderFns } from "./home.vue?vue&type=template&id=ddc72a5a&scoped=true&lang=pug"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=ddc72a5a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc72a5a",
  null
  
)

export default component.exports